import { render, staticRenderFns } from "./ServiceOnline.vue?vue&type=template&id=52eccc86&scoped=true"
import script from "./ServiceOnline.vue?vue&type=script&lang=js"
export * from "./ServiceOnline.vue?vue&type=script&lang=js"
import style0 from "./ServiceOnline.vue?vue&type=style&index=0&id=52eccc86&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../空降-sp-弯弯介绍的/kj-德语-源码/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52eccc86",
  null
  
)

export default component.exports